import { Controller } from "@hotwired/stimulus";

/**
 * Opens a GO4S DS modal that lives elsewhere in the page, by the id of its
 * root (shared/ds/modal, local `id`). A dropdown-menu item is teleported to
 * <body>, out of reach of the modal's own actions: it goes through here.
 * Open menus are closed first (they listen to Escape).
 */
export default class extends Controller {
  static values = { id: String };

  open(event) {
    event.preventDefault();
    document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape" }));
    window.dispatchEvent(new CustomEvent("ds-modal:open", { detail: { id: this.idValue } }));
  }
}
